import React from 'react';
import SourceFieldset from '@/features/quickSetup/SourceFieldset';
import TemplateSelector from '@/features/quickSetup/TemplateSelector';
import WizardFormLayout from '@/features/quickSetup/WizardFormLayout';
import { ToggleField } from '@/components/ui';
import type { QuickSetupFormState } from '@/features/quickSetup/types';
import type { Source } from '@/types';

type Props = {
  form: QuickSetupFormState;
  sources: Source[];
  onChange: (patch: Partial<QuickSetupFormState>) => void;
  onToggleSource: (name: string) => void;
  onSetSourceNames?: (names: string[]) => void;
  sourcesEmptyHint?: string;
};

export default function JobWizard({
  form,
  sources,
  onChange,
  onToggleSource,
  onSetSourceNames,
  sourcesEmptyHint,
}: Props) {
  return (
    <WizardFormLayout
      aside={
        <>
          <TemplateSelector category="jobs" form={form} onApply={onChange} />
          <SourceFieldset
            sources={sources}
            selected={form.source_names}
            onToggle={onToggleSource}
            onSetSelected={onSetSourceNames}
            emptyHint={sourcesEmptyHint}
          />
        </>
      }
    >
      <div className="wizard-field-grid">
        <label className="wizard-field-span-2">
          Keyword
          <input
            value={form.keyword}
            onChange={(e) => onChange({ keyword: e.target.value })}
            placeholder="Python developer"
          />
        </label>

        <label>
          Location
          <input
            value={form.location}
            onChange={(e) => onChange({ location: e.target.value })}
            placeholder="Zagreb, Remote…"
          />
        </label>

        <label>
          Salary min (EUR)
          <input
            type="number"
            value={form.salary_min}
            onChange={(e) => onChange({ salary_min: e.target.value })}
          />
        </label>

        <ToggleField
          checked={form.remote_only}
          onChange={(next) => onChange({ remote_only: next })}
          label="Remote only"
          className="wizard-field-span-2"
        />
      </div>
    </WizardFormLayout>
  );
}
